export type MunilyDatePickerModalResult = {
  /** ISO `yyyy-MM-dd` */
  date: string;
};

export type MunilyDatePickerModalData = {
  titleKey?: string;
  closeAriaKey?: string;
  /** ISO `yyyy-MM-dd` or `Date` */
  initialDate?: string | Date;
  minDate?: Date;
  maxDate?: Date;
  labelButtonCancelKey?: string;
  labelButtonConfirmKey?: string;
  /** Returns true when the ISO date must not be selectable */
  isDateDisabled?: (isoDate: string) => boolean;
  /** Fired when the user navigates to another month in the calendar */
  onMonthChange?: (event: { month: number; year: number }) => void;
};

export const MUNILY_DATE_PICKER_MODAL_PANEL_CLASS = 'munily-date-picker-modal';
